const NavbarJson = [
  {
    id: 1,
    name: "Architecture",
    slug: "architecture",
    subMenu: [
      "Culture",
      "Education",
      "Work",
      "Hospitality",
      "Residential",
      "Infrastructure",
      "Space",
      "Sport",
      "Health"
    ]
  },
  {
    id: 2,
    name: "Interiors",
    slug: "interiors",
    subMenu: [] // future
  },
  {
    id: 3,
    name: "Landscape",
    slug: "landscape",
    subMenu: [
      "Civic Spaces",
      "Parks",
      "Gardens",
      "Balconies/Terraces"
    ]
  },
  {
    id: 4,
    name: "Planning",
    slug: "planning",
    subMenu: [
      "Campus",
      "City",
      "Region"
    ]
  },
  {
    id: 5,
    name: "Products",
    slug: "products",
    subMenu: [
      "Lighting",
      "Furniture",
      "Consumer Products",
      "Mobility",
      "Installation"
    ]
  }
];

export default NavbarJson;
